import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex, setFontSizeLineHeightRem } from 'src/styles/utils';

export const parentalPopupWrap = styled.div<{ socialLoginType: string }>`
  text-align: center;
  ${flex('column', 'center', 'center')};
  color: ${colors.white};
  min-height: 200px;
  ${MQ.MediaMd} {
    height: 100%;
  }
  .parentalSocialLoginWrap {
    .socialOr {
      display: none;
    }
    .loginSocialIcon {
      display: none;
    }
    .socialFacebookLogin {
      display: ${(props) =>
        props.socialLoginType === 'facebook' ? `block` : `none`};
    }
    .socialTwitterLogin {
      display: ${(props) =>
        props.socialLoginType === 'twitter' ? `block` : `none`};
    }
    .socialGoogleLogin {
      display: ${(props) =>
        props.socialLoginType === 'google' ? `block` : `none`};
    }
    .socialAppleLogin {
      display: ${(props) =>
        props.socialLoginType === 'apple' ? `block` : `none`};
    }
  }
`;

export const title = css`
  ${ZeeFontBold(16, 24)};
  margin: 0 0 12px;
  ${MQ.MediaLg} {
    margin: 0 0 6px;
    ${setFontSizeLineHeightRem(24, 32)}
  }
`;

export const descripton = css`
  ${ZeeFontRegular(12, 16)};
  margin: 0 0 32px;
  ${MQ.MediaLg} {
    ${setFontSizeLineHeightRem(20, 28)}
  }
`;

export const btn = css`
  color: ${colors.white};
  ${ZeeFontBold(14, 20)};
  height: 44px;
  width: 100%;
  max-width: 300px;
`;
